import { render, staticRenderFns } from "./ListCostCentre.vue?vue&type=template&id=32afb35a"
import script from "./ListCostCentre.vue?vue&type=script&lang=js"
export * from "./ListCostCentre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListCostCentre.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32afb35a')) {
      api.createRecord('32afb35a', component.options)
    } else {
      api.reload('32afb35a', component.options)
    }
    module.hot.accept("./ListCostCentre.vue?vue&type=template&id=32afb35a", function () {
      api.rerender('32afb35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListCostCentre.vue"
export default component.exports